import { useParams } from "react-router-dom";
import EditClientUser from "./EditClientUser";
import { useGetClientUserByIdQuery } from "../../../../reactQueries/AppApi/rqHooksForClientUsers";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";
import {  useGetClientTypeClassificationQuery } from "../../../../reactQueries/commonRQHooks";
const EditClientUserHome = () => {
  let { Id } = useParams();
  /**API calls */
  const {
    isSuccess,
    isFetching,
    data: clientUserDataById,
    isError,
  } = useGetClientUserByIdQuery({ Id });

  const { data: ClientTypeList } = useGetClientTypeClassificationQuery();

  return (
    <div>
      {
        (!!isFetching) && "Wait, Loading...."
      }
      {!!isSuccess && (
        <EditClientUser clientUserDataById={clientUserDataById} ClientTypeList={ClientTypeList || []}/>
      )}

      <MpgErrorDialog
        open={!!isError}
      />
    </div>
  );
};
export default EditClientUserHome;
